import { Vue, Component } from 'vue-property-decorator';

@Component
export default class IsExclusiveFilterMixin extends Vue {
    private isExclusive!: boolean;

    private isExclusiveCount!: number;

    private isExclusiveCountOverall!: number;

    updateInput({ target }: { target: HTMLInputElement}): void {
        this.$emit('change-value', target.checked);
    }

    get isChecked(): boolean {
        return this.isExclusive;
    }

    get showFilter(): boolean {
        return this.isExclusiveCountOverall > 0 || this.isChecked;
    }

    get disabled(): boolean {
        return this.isExclusiveCount === 0 && !this.isExclusive;
    }
}